import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@junglescout/edna'
import styled from 'styled-components'
import { t } from 'i18next'

const SyncStatusFailed = styled.span`
  color: ${props => props.theme.colors.red500};
`

const getTooltip = (isChild, syncStatus) => {
  switch (isChild && syncStatus === null ? 0 : syncStatus) {
    case 0:
      return t(
        'product_costs_and_settings:syncStatus.defaultTooltip',
        "The product's information is out of sync with Amazon's data so click the Sync button to update it."
      )
    case 1:
      return t(
        'product_costs_and_settings:syncStatus.inProgressTooltip',
        "The product's information is being updated so check back in a few minutes"
      )
    case 2:
      return t(
        'product_costs_and_settings:syncStatus.succeededTooltip',
        "The product's information is up to date."
      )
    case 3:
      return t(
        'product_costs_and_settings:syncStatus.failedTooltip',
        'There may be a sync delay between Amazon and Jungle Scout or a connectivity issue.'
      )
    default:
      return null
  }
}

const getText = (isChild, syncStatus) => {
  switch (isChild && syncStatus === null ? 0 : syncStatus) {
    case 0:
      return t('product_costs_and_settings:syncStatus.default', 'Need to sync')
    case 1:
      return t(
        'product_costs_and_settings:syncStatus.inProgress',
        'Sync in progress...'
      )
    case 2:
      return t(
        'product_costs_and_settings:syncStatus.succeeded',
        'Synced with Amazon'
      )
    case 3:
      return (
        <SyncStatusFailed>
          {t('product_costs_and_settings:syncStatus.failed', 'Failed to sync')}
        </SyncStatusFailed>
      )

    default:
      return '--'
  }
}

export default function SyncStatusColumn({ syncStatus, totalChildren }) {
  const isParent = totalChildren > 1

  return (
    <Tooltip
      side="bottom"
      content={getTooltip(!isParent, syncStatus)}
      size="large">
      <div>{getText(!isParent, syncStatus)}</div>
    </Tooltip>
  )
}

SyncStatusColumn.defaultProps = {
  syncStatus: null,
  totalChildren: 0
}

SyncStatusColumn.propTypes = {
  syncStatus: PropTypes.number,
  totalChildren: PropTypes.number
}
